import { Fragment, type ReactNode } from 'react';

export const highlightText = (text: string, query: string): ReactNode => {
  if (!text) return text;
  if (!query) return text;

  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery.length) return text;

  const normalizedText = text.toLowerCase();
  let matchIndex = normalizedText.indexOf(normalizedQuery);
  if (matchIndex === -1) return text;

  const elements: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;

  while (matchIndex !== -1) {
    if (matchIndex > lastIndex) {
      elements.push(
        <span key={`text-${key++}`}>{text.slice(lastIndex, matchIndex)}</span>
      );
    }

    const match = text.slice(matchIndex, matchIndex + normalizedQuery.length);
    elements.push(
      <span key={`highlight-${key++}`} className='library-search-highlight'>
        {match}
      </span>
    );

    lastIndex = matchIndex + normalizedQuery.length;
    matchIndex = normalizedText.indexOf(normalizedQuery, lastIndex);
  }

  if (lastIndex < text.length) {
    elements.push(<span key={`text-${key++}`}>{text.slice(lastIndex)}</span>);
  }

  if (elements.length === 1) {
    return elements[0];
  }

  return <Fragment>{elements}</Fragment>;
};
